import { render, staticRenderFns } from "./ChangePassword1.vue?vue&type=template&id=b53fca00&scoped=true"
import script from "./ChangePassword1.vue?vue&type=script&lang=js"
export * from "./ChangePassword1.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword1.vue?vue&type=style&index=0&id=b53fca00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53fca00",
  null
  
)

export default component.exports